import { inject, InjectionToken } from '@angular/core';
import { MetaService } from '../services';

export const META_TOKEN: InjectionToken<MetaProvider> = new InjectionToken<MetaProvider>('META_TOKEN', {
  factory: (): MetaProvider => {
    const service: MetaService = inject(MetaService);

    return {
      initialize(): Promise<void> {
        return service.initialize();
      }
    };
  }
});

export interface MetaProvider {
  initialize(): Promise<void>;
}
